var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinimize = function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4445 18.3333L21.4444 13.6666L10.5555 13.6667L10.5556 18.3333L21.4445 18.3333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22222 2C4.78578 2 2 4.78578 2 8.22222V23.7778C2 27.2142 4.78579 30 8.22223 30L23.7778 30C27.2142 30 30 27.2142 30 23.7778V8.22222C30 4.78578 27.2142 2 23.7778 2H8.22222ZM5.11111 8.22222C5.11111 6.504 6.504 5.11111 8.22222 5.11111L23.7778 5.11111C25.496 5.11111 26.8889 6.504 26.8889 8.22222V23.7778C26.8889 25.496 25.496 26.8889 23.7778 26.8889L8.22223 26.8889C6.50401 26.8889 5.11111 25.496 5.11111 23.7778L5.11111 8.22222Z",
    fill: "currentColor"
  })));
};
export default SvgMinimize;